import React, { useContext } from 'react';
import { Slice } from 'gatsby';
import MaskContext, { MaskProvider } from 'context/maskContext';
import { classnames } from 'helpers/utils';
import * as styles from './layout.module.scss';

export interface LayoutProps {
  children: React.ReactNode
}

export const Layout = (props: LayoutProps) => {
  const { showMask } = useContext(MaskContext);

  return (
    <MaskProvider>
      <div className={styles.pageContainer}>
        <Slice alias="header" />
        {showMask && <div className={styles.mask} />}
        <div className={classnames(styles.contentWrap, showMask ? styles.masked : '')}>
          {props.children}
        </div>
        <div className={showMask ? styles.masked : ''}>
          <Slice alias="footer" />
        </div>
        <div id="modal" />
      </div>
    </MaskProvider>
  );
};
